import MatchedMap from 'utilities/src/matchedMap';

import { ButtonBGEnum } from '../../../../types/_bg';

import buttonSiteBrandLightTheme from './_light';
import buttonSiteBrandDarkTheme from './_dark';

export default new MatchedMap([
  [ButtonBGEnum.Light, buttonSiteBrandLightTheme],
  [ButtonBGEnum.Dark, buttonSiteBrandDarkTheme],
]);
